import {RouteProxyProps} from '../types';

export default function DefaultRouteProxy({
    component: Component,
}: RouteProxyProps) {
    return <Component />;
}
